<template>
  <BaseModal>
    <CircleToggle
      :value="add_new"
      @input="add_new = true"
    >{{ $t('add_modificator_group_modal.add_new') }}</CircleToggle>

    <CircleToggle
      class="mt-15"
      :value="!add_new"
      @input="add_new = false"
    >{{ $t('add_modificator_group_modal.add_existing') }}</CircleToggle>
    <hr/>
    <p
      class="comment c-grey iqos-group-item mb-0"
      v-if="!add_new"
    >{{ $t('add_modificator_group_modal.add_existing_desc') }}</p>
    
    <BlackSelect class="iqos-group-item" v-if="!add_new" v-model="selected_group">
      <option :value="null" disabled>{{ $t('add_modificator_group_modal.select_ph') }}</option>
      <option
        v-for="(item,index) in price_groups"
        :value="index"
        :key="index"
      >{{ getName(item) }} ({{ item.product_name }}, {{item.category}})</option>
    </BlackSelect>

    <div v-if="add_new">
      <CircleToggle
        :value="single_select"
        @input="single_select = true"
      >{{$t('modificators_settings.single_select')}}</CircleToggle>
      <CircleToggle
        :value="!single_select"
        @input="single_select = false"
        class="mt-15"
      >{{$t('modificators_settings.multi_select')}}</CircleToggle>
    </div>

    <div v-if="add_new && single_select" class="max-count-control">
      <RoundCheckbox v-model="set_limit">
        {{ $t('modificators_settings.allow_max_count') }}
      </RoundCheckbox>
      <BaseInput 
        v-if="set_limit" 
        type="number" 
        :readonly="false"
        class="iqos-group-item"
        :valid="!max_count_invalid"
        v-model.number="max_count" :placeholder="$t('modificators_settings.max_count_placeholder')">

      </BaseInput>
    </div>

    <div class="buttons-container">
      <DashboardButton
        variant="danger"
        class="modal-button cancel"
        @click="onClose"
      >{{ $t('add_modificator_group_modal.cancel') }}</DashboardButton>
      <DashboardButton
        variant="success"
        class="modal-button"
        @click="onConfirm"
      >{{ $t('add_modificator_group_modal.confirm') }}</DashboardButton>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/modals/BaseModal.vue";
import CircleToggle from "@/components/CircleToggle.vue";
import BlackSelect from "@/components/BlackSelect.vue";
import BlackInput from "@/components/BlackInput.vue";
import DashboardButton from "@/components/DashboardButton.vue";
import RoundCheckbox from "@/components/RoundCheckbox.vue"

export default {
  data() {
    return {
      add_new: true,
      selected_group: null,

      single_select: true,
      set_limit: false,
      max_count: null,

      max_count_invalid: false
    };
  },
  methods: {
    getName(item) {
      if (item.content.name) return item.content.name;

      return item.content.single_select
        ? this.$t("menu_settings.variants")
        : this.$t("menu_settings.additions");
    },
    onClose() {
      this.$emit("close");
    },
    onConfirm() {
      if (this.add_new) {
        let items = [
          {
            name: null,
            price: null,
            weight: null,
            stock: true
          },
        ];

        if (this.single_select) {
          items.push({
            name: null,
            price: null,
            weight: null,
            stock: true
          });

          if (!this.max_count) this.max_count = 1;

          if (this.set_limit && (!this.max_count || this.max_count <= 0)) {
            this.max_count_invalid = true;
            return;
          } 
        } else {
          this.max_count = 999;
        }

        this.$store.commit("menu/addPriceGroup", {
          name: null,
          single_select: this.single_select,
          max_count: this.max_count,
          items,
        });
      } else {
        if (!this.selected_group) return;

        const dereferenced_copy = JSON.parse(
          JSON.stringify(this.price_groups[this.selected_group].content)
        );

        this.single_select = dereferenced_copy.single_select;

        this.$store.commit("menu/addPriceGroup", dereferenced_copy);
      }

      // if (this.single_select) {
      //   this.$store.commit("menu/setProductData", {
      //     key: "poster_product_id",
      //     value: null,
      //   });

      //   if (this.dish.base_price === null) {
      //     this.$store.commit("menu/setProductData", {
      //       key: "base_price",
      //       value: 0,
      //     });
      //   }
      // }

      this.$store.dispatch("menu/updateProduct");

      this.$store.dispatch("auditlog/write", {
        type: "create_menu_product_modificators",
        payload: {
          dish_name: this.dish.name,
          dish_id: this.dish._id,
          single_select: this.single_select
        },
      });

      this.$emit("close");
    },
  },
  computed: {
    price_groups() {
      return this.$store.getters["menu/allPriceGroups"];
    },
    dish() {
      return this.$store.state.menu.product;
    },
  },
  components: {
    BaseModal,
    CircleToggle,
    BlackSelect,
    BlackInput,
    DashboardButton,
    RoundCheckbox
  },
};
</script>

<style scoped>
.buttons-container {
  display: flex;
  justify-content: space-between;
  margin-top: 2vh;
  width: 100%;
}

/* .modal-button {
  background: transparent;
  font-size: 2vh;
  border: 1px solid #ededed;
  color: #ededed;
  text-align: center;
  padding: 0.5vh 1vh;
  border-radius: 0.8vh;
  cursor: pointer;
} */

p.comment {
  font-size: 1.7vh;
}

.max-count-control {
  margin-top: 3.4vh;
}

/* .cancel {
  border: 1px solid #908f8d;
  color: #908f8d;
} */
</style>